import fondoTextura from "../../img/mediakit/fondo-textura.png";
import skyline from "../../img/mediakit/lamina01-skyline.jpg";
import foto02 from "../../img/mediakit/lamina02-foto.jpg";
import foto03 from "../../img/mediakit/lamina03-foto.jpg";
import logoWecast from "../../img/mediakit/wecast-logo-vector.svg";

// Fase B, precarga (2026-09-26): manifiesto ÚNICO de todas las imágenes del mediakit, EN ORDEN DE
// LÁMINA (10.1) — MediakitDataProvider las precarga todas al montar el visor, para que ninguna
// aparezca a medio cargar al llegar a su lámina. Cada lámina nueva con imágenes suma las suyas acá,
// reusando el mismo import que ya usa su componente (nunca una ruta duplicada).
export const MEDIAKIT_IMAGENES = [
  fondoTextura, // fondo compartido de TODAS las láminas (Visor.module.scss) — va primero, es el que se ve enseguida
  skyline,
  logoWecast,
  foto02,
  foto03,
];
